import styled from 'styled-components';
import { Title } from '../../../CommonComponents/Typography';

export const StyledTitle = styled(Title)`
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: 600;
`;

export const Explanations = styled.div`
  display: flex;
  margin: 32px 0;

  > * {
    flex-grow: 1;

    & + & {
      margin-left: 32px;
    }
  }
`;

export const Panel = styled.div`
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
`;

export const Page = styled.div`
  padding-bottom: 32px;
  color: #444;
`;

export const Actions = styled.div`
  text-align: right;

  > * + * {
    margin-left: 32px;
  }
`;

export const Error = styled.div`
  color: #f93e3f;
  font-size: 14px;
  padding: 5px 0;
`;

export const Success = styled.div`
  color: #56c568;
  font-size: 14px;
  padding: 5px 0;
`;
